import { render, staticRenderFns } from "./modal-order-reorder.vue?vue&type=template&id=faf54c9c&scoped=true"
import script from "./modal-order-reorder.vue?vue&type=script&lang=js"
export * from "./modal-order-reorder.vue?vue&type=script&lang=js"
import style0 from "./modal-order-reorder.vue?vue&type=style&index=0&id=faf54c9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf54c9c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseAlert: require('/home/ploi/www.orderchamp.dev-deploy/www.orderchamp.dev/22072026_100728/resources/assets/marketplace/components/BaseAlert.vue').default,BaseButton: require('/home/ploi/www.orderchamp.dev-deploy/www.orderchamp.dev/22072026_100728/resources/assets/marketplace/components/BaseButton.vue').default})
